import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { Sorting } from 'components/sorting';
import { LoadingSpinner } from 'components/loading-spinner';
import { Button } from 'components/button';
import { collectionSelector } from 'common/selectors';
import { urlVideoIdSelector } from 'pages/channel.page';
import { urlSortSelector } from 'common/selectors/router';
import * as PropTypes from 'prop-types';
import { VideoListLoader } from 'components/video-list-loader';

const MobileContainer = ({
  baseUrl,
  videoId,
  sortBy,
  withSort,
  collectionTotalCount,
  isLoading,
  collectionVideos,
  showLoadMore,
  loadMore,
  showLoader,
  children,
  t,
}) => (
  <div className={'ct-mobile-collection'}>
    {withSort && collectionTotalCount > 0 && (
      <div className={'ct-mobile-collection__sorting'}>
        <Sorting link={`${baseUrl}/1/${videoId ? videoId : ''}`} videoId={videoId} sortBy={sortBy} />
      </div>
    )}

    {collectionTotalCount === -1 ? (
      <VideoListLoader errorMsg={'channel_no_videos'} isLoading={isLoading} videos={collectionVideos} />
    ) : (
      children
    )}

    {showLoadMore && (
      <div className="ct-mobile-collection__show-more">
        <Button secondary={true} onClick={loadMore}>
          {t('show-more-videos')}
        </Button>
      </div>
    )}

    {showLoader && <LoadingSpinner />}
  </div>
);

const mapStateToProps = (state, { match }) => {
  const { pageNum, perPage, totalCount, isLoading, videos } = collectionSelector(state);

  const shouldBeOnThePage = Math.min(perPage, totalCount - (pageNum - 1) * perPage);
  const isThereMoreVideos = shouldBeOnThePage > videos.length;
  const isLoadingFirstTime = totalCount === -1;

  return {
    isLoading,
    collectionTotalCount: totalCount,
    collectionVideos: videos,
    videoId: urlVideoIdSelector(state, match),
    sort: urlSortSelector(state, match),
    showLoadMore: !isLoading && totalCount > videos.length,
    showLoader: (isLoading || isThereMoreVideos) && !isLoadingFirstTime,
  };
};

export const MobileContainerDecorated = compose(
  withRouter,
  withTranslation(),
  connect(mapStateToProps)
)(MobileContainer);

MobileContainerDecorated.propTypes = {
  baseUrl: PropTypes.string.isRequired,
  loadMore: PropTypes.func.isRequired,
  withSort: PropTypes.bool.isRequired,
  sortBy: PropTypes.array,
  children: PropTypes.object,
};
